import React from 'react';
import PropTypes from 'prop-types';
import CapSelect from '../CapSelect';
import CapRow from '../CapRow';
import CapHeading from '../CapHeading';
import CapTable from '../CapTable';
import CapColumn from '../CapColumn';
import { injectIntl, FormattedMessage } from 'react-intl';
import './index.scss';
import messages from './messages';
import { StyledCapToolTipWithInfo } from './style';

const CapVerticalGroupTable = props => {
  const {
    fieldsHeader,
    fieldsDescription,
    getDataSource,
    getColumns,
    options,
    identifier,
    setIdentifier,
    header,
    info,
    placeholder,
  } = props;

  return (
    <div>
      {options.length > 0 && (
        <CapRow className="align-items-center" span={24}>
          <CapHeading type="h3" className="unique-identifier-row">
            {header}
          </CapHeading>
          <StyledCapToolTipWithInfo title={info} />
          <CapSelect.CapCustomSelect
            width="15rem"
            defaultValue={null}
            selectPlaceholder={placeholder}
            options={options}
            value={identifier}
            onChange={value => {
              setIdentifier(value);
            }}
          />
        </CapRow>
      )}
      <CapRow className="align-items-center" span={24}>
        <CapColumn>
          {fieldsHeader && (
            <CapHeading type="h3" className="map-fields-heading">
              {fieldsHeader}
            </CapHeading>
          )}
          {fieldsDescription && (
            <CapHeading type="h6" className="map-fields-description">
              {fieldsDescription}
            </CapHeading>
          )}
        </CapColumn>
      </CapRow>
      <CapRow className="align-items-center" span={24}>
        <CapTable
          columns={getColumns}
          dataSource={getDataSource}
          locale={{
            emptyText: <FormattedMessage {...messages.noDataFound} />,
          }}
          className="ftp-connector-group-table"
          pagination={false}
        />
      </CapRow>
    </div>
  );
};

CapVerticalGroupTable.defaultProps = {
  fieldsHeader: '',
  fieldsDescription: '',
  getColumns: [],
  getDataSource: [],
  options: [],
  identifier: '',
  setIdentifier: () => {},
};

CapVerticalGroupTable.propTypes = {
  fieldsHeader: PropTypes.string,
  fieldsDescription: PropTypes.string,
  getColumns: PropTypes.array,
  getDataSource: PropTypes.array,
  options: PropTypes.array,
  identifier: PropTypes.string,
  setIdentifier: PropTypes.func,
};

export default injectIntl(CapVerticalGroupTable);
